import { StudyTimeOptions } from '@/constants/studyTimeOptions';
import { KollelFormData } from '../schemas/kollelFormSchema';
import { KollelFormPayload, UpdateKollelAvrechsDtoIn } from '@/models/in/KollelDtoIn';

/**
 * Step 1's fields → the create-kollel payload (KollelsController.CreateKollel).
 *
 * KollelFormData is z.input of the schema, so every defaulted field is optional at the type level
 * even though the form never actually submits without it (zodResolver validates first) - the
 * fallbacks below are for the type system, same defensive style as newProject's mapFormDataToDto.
 */
export const mapFormDataToDto = (data: KollelFormData): KollelFormPayload => ({
  name: data.name?.trim() ?? '',
  address: data.address?.trim() ?? '',
  studyTime: data.defaultStudyTime ?? StudyTimeOptions.Morning,
  roshKollelContact: {
    name: data.roshKollelContact?.name?.trim() ?? '',
    email: data.roshKollelContact?.email?.trim() ?? '',
    phone: data.roshKollelContact?.phone?.trim() ?? '',
  },
  supervisingBodyContact: {
    name: data.supervisingBodyContact?.name?.trim() ?? '',
    email: data.supervisingBodyContact?.email?.trim() ?? '',
    phone: data.supervisingBodyContact?.phone?.trim() ?? '',
  },
  notes: '',
  excellenceLimit: data.excellenceLimit ?? null,
  examsLimit: data.examsLimit ?? null,
  punctualityLimit: data.punctualityLimit ?? null,
});

/**
 * Steps 2-3's avrechs → the avrechs-reconcile payload (KollelsController.UpdateKollelAvrechs).
 * When scheduleMode is 'same', every row's override is dropped - the kollel's own
 * defaultStudyTime (set on the Kollel itself in step 1's payload) is what every avrech follows.
 */
export const mapAvrechsToDto = (data: KollelFormData): UpdateKollelAvrechsDtoIn => ({
  avrechs: (data.avrechs ?? []).map((a) => ({
    supportedId: a.supportedId,
    studyTimeOverride: data.scheduleMode === 'different' ? (a.studyTimeOverride ?? null) : null,
    confirmTransfer: a.transferFromKollelId != null,
  })),
});
